<p>
  child-entity-add-list-dialog works!
</p>
